module.exports = __webpack_public_path__ + "media/images/pic/banners/stationary-courses-7e7f0bd5a7a1e7032f9922c8b3c8ddb7.svg";